'use client'
import { MoonIcon, SunIcon } from '@heroicons/react/24/solid'
import { useTheme } from '@wrksz/themes/client'
import { useEffect, useState } from 'react'

export function ThemeChanger() {
  const { theme, setTheme } = useTheme()
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
  }, [])

  if (!mounted) {
    return null
  }

  return (
    <>
      {theme === 'dark' ? (
        <SunIcon
          className='h-6 w-6 cursor-pointer text-contentInverseSecondary'
          onClick={() => setTheme('light')}
        />
      ) : (
        <MoonIcon
          className='h-6 w-6 cursor-pointer text-contentInverseSecondary'
          onClick={() => setTheme('dark')}
        />
      )}
    </>
  )
}
